import React from 'react';
import { Link } from 'react-router-dom';

import Heading from '../../components/stateless/Heading';
import Description from '../../components/stateless/Description';
import IconCard from '../../components/stateless/IconCard';
import BMESlider from '../../components/stateless/BMESlider';
import Button from '../../components/statefull/Button';

import MainImg from '../../assets/imgs/main.svg';
import Tools from '../../assets/imgs/tools.svg';
import Services from '../../assets/imgs/services.svg';
import Collaborate from '../../assets/imgs/collaborate.svg';

import { ProductsList } from '../../constants';

import './index.scss';

const { REACT_APP_BME_URL } = process.env;

const Home = () => (
  <main className="section-container">
    <div className="container-layout">
      <div className="product-container crate-content">
        <div className="info-block-text">
          <p className="create-block-title">Create, manage and grow <br/> your iGaming business</p>
          <p className="block-txt">
            Get started with BetConstruct’s acclaimed
            all-in-one iGaming console <strong>SpringBME</strong>.
            Create and manage your gaming or betting website.
            Enhance it with our ever-growing base of top-grade products, tools and services.
          </p>
            <Link className="block-txt" to="/about">Learn more about SpringBME</Link>
          {/*<div>
            <Button withIcon={true} icon="play-icon" content="How It Works" />
          </div>*/}
        </div>
        <div className="img-wrapper">
          <img src={MainImg} alt="MainImg"/>
        </div>
      </div>
    </div>
    <div className="products-wrapper content-item-with-bg">
          {/*<Heading*/}
            {/*size="medium"*/}
            {/*content="Products"*/}
          {/*/>*/}
          <div className="products-top-block-inner">
            <p className="products-block-title">products</p>
            <BMESlider sliderItems={ProductsList} />
          </div>
        <div className="products-bottom-block">
          <div className="container-layout">
            <div className="product-container">
              <div className="img-wrapper">
                <img src={Tools} alt="Tools"/>
              </div>
              <div className="info-block-text">
                <p className="products-block-title">Tools</p>
                <p className="description-txt">Equip your iGaming operation with BetConstruct’s essential cutting-edge tools: Affiliate Marketing Software, Agent System Software, Umbrella (Risk Management), CRM</p>
              </div>
            </div>
            <div className="product-container revers">
              <div className="info-block-text">
                <p className="products-block-title">Services</p>
                <p className="description-txt">Get access to BetConstruct’s highly-appraised Risk Management, Customer Support services.</p>
              </div>
              <div className="img-wrapper">
                <img src={Services} alt="Services"/>
              </div>
            </div>
            <div className="start-journey">
              <p className="journey-title">The First Steps to Start Your Journey</p>
              <div className="start-journey-container fill">
                <div className="start-journey-container-item">
                  <IconCard
                      icon="registerVerify"
                      size="medium"
                      color="primary"
                      shadow={true}
                      bgGray={false}
                  />
                  <p className="start-journey-title">Register and Verify</p>
                  <p className="start-journey-txt">Get a SpringBME account to access the ever-expanding features of the all-in-one iGaming console</p>
                </div>
                <div className="start-journey-container-item">
                  <IconCard
                      icon="projectType"
                      size="medium"
                      color="primary"
                      shadow={true}
                      bgGray={false}
                  />
                  <p className="start-journey-title">Choose a Project Type</p>
                  <p className="start-journey-txt">White Label, Turnkey, API-based solutions for your iGaming operation - all just a few clicks away</p>
                </div>
                <div className="start-journey-container-item">
                  <IconCard
                      icon="configure"
                      size="medium"
                      color="primary"
                      shadow={true}
                      bgGray={false}
                  />
                  <p className="start-journey-title">Configure</p>
                  <p className="start-journey-txt">With our website engines SpringBuilder X or CMS, the website customisation process is a piece of cake. Polish the look of your website with easy-to-employ editing modes.</p>
                </div>
              </div>
              <a target="_blank" href={`${REACT_APP_BME_URL}projects/type`}>
                <div className="btn-wrapper">
                  <Button  filled={true} content="Create Project" />
                </div>
              </a>
            </div>
          </div>
        </div>
        {/*<div className="grid-2">
          <div>
            <Heading
              size="medium"
              content="MarketplaceResurse"
            />
            <Description
              size="large"
              content="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Eros eleifend dis egestas euismod laoreet. Viverra faucibus vitae, aliquam felis, pellentesque aenean at vulputate. Viverra faucibus vitae, aliquam felis, pellentesque aenean at vulputate."
            />
            <Button filled={true} content="See All"/>
          </div>
          <div className="img-wrapper">
            <img src={MarketplaceResurse} alt="MarketplaceResurse"/>
          </div>
        // </div>*/}
    </div>
    <div className="order-services-wrapper">
      <div className="container-layout">
        <div className="product-container">
          <div className="info-block-text">
            <p className="collaborate-title">Order Services</p>
            <p className="description-txt"> We at BetConstruct do our best to help you run your operation and meet any specific needs related to it. In the light of that, we provide services in support of your business . Our specific service offers are available to BetConstruct network partners. If interested, become one and sign in to your SpringBME account to see those.</p>
            <a   href={`/services`}>
              <div className="btn-wrapper">
                <Button  filled={true} content="Learn More">
                  <a href={`${REACT_APP_BME_URL}projects/type`}/>
                </Button>
              </div>
            </a>
          </div>
          <div className="img-wrapper">
            <div className="img-wrapper-inner">
              <IconCard
                  icon="subtract"
                  color="primary"
                  shadow={true}
                  bgGray={false}
              />
              <span className="img-wrapper-inner-txt">Risk Management</span>
            </div>
            <div className="img-wrapper-inner">
              <IconCard
                  icon="web-design"
                  color="primary"
                  shadow={true}
                  bgGray={false}
              />
              <span className="img-wrapper-inner-txt">Design</span>
            </div>
            <div className="img-wrapper-inner">
              <IconCard
                  icon="handshake"
                  color="primary"
                  shadow={true}
                  bgGray={false}
              />
              <span className="img-wrapper-inner-txt">Customer Relationship</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="collaborate-wrapper">
      <div className="container-layout">
        <div className="product-container">
          <div className="img-wrapper">
            <img src={Collaborate} alt="Collaborate"/>
          </div>
          <div className="info-block-text">
            <p className="collaborate-title">Ready To Collaborate?</p>
            <p className="description-txt"> Explore <a className="block-txt" target="_blank" href={REACT_APP_BME_URL}>SpringBME</a> before you plunge into creating and managing your iGaming operation.</p>
            <div className="demo-btn-wrap">
              <Button link="/request-demo" filled={true} green={true} content="Request a demo"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
);

export default Home;
